/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Tag_Standar_InvalidInputs */

const es_co2_error_tag_standar_invalid = /** @type {(inputs: Error_Tag_Standar_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El valor de la etiqueta a @Standar no es válido.`)
};

/**

* @param {Error_Tag_Standar_InvalidInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_tag_standar_invalid = /** @type {((inputs?: Error_Tag_Standar_InvalidInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Tag_Standar_InvalidInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_tag_standar_invalid(inputs)
});